import React from 'react';
import { Box, Button, Dropdown, Select, Checkbox, Image, Alert, Typography, Grid, TextField, Calendar } from '@iho-design-system/Loader';
import moment from 'jalali-moment';



import CalendarSVG from '../../assets/images/icons/calendar.svg';
import profileImg from '../../assets/images/icons/user-profile.svg';
import iconDownSVG from '../../assets/images/icons/chevron-down.svg';
import getAPI from './../../api/get';
import AgencyProfile from '../../api/edit/AgencyProfile';

export default function UploadLicense() {
    const [ColorBar, setColorBar] = React.useState('succuss-bar');
    const [Err, setErr] = React.useState(false);
    const [showResult, setshowResult] = React.useState(false)
    const [Docs, setDocs] = React.useState({

        DocA: {
            files: null,
            FileName: '',
            DocType: 1,
            showProgress: false,
            showLbl: false
        },
        DocB: {
            files: null,
            FileName: '',
            DocType: 2,
            showProgress: false,
            showLbl: false
        },
        DocJ: {
            files: null,
            FileName: '',
            DocType: 3,
            showProgress: false,
            showLbl: false
        },
        DocRaja: {
            files: null,
            FileName: '',
            DocType: 4,
            showProgress: false,
            showLbl: false
        },
        FileAnnouncement: {
            files: null,
            FileName: '',
            DocType: 5,
            showProgress: false,
            showLbl: false
        },
        ScanContract: {
            files: null,
            FileName: '',
            DocType: 6,
            showProgress: false,
            showLbl: false
        },
        NationalCodeScan: {
            files: null,
            FileName: '',
            DocType: 7,
            showProgress: false,
            showLbl: false
        },


    })

    const [progress, setProgress] = React.useState();
    const typeUser = localStorage.getItem('userType');

    /*
          - alert
      */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 3000);
    }

    React.useEffect(() => {
        const fetchData = async () => {



            let userTypeParameters = {
                ctrl: 'AgencyProfile',
                method: 'GetDocs',
                query: ''
            }







            let response = await getAPI(userTypeParameters);
            if (response.status == 200) {
                response.data.forEach(item => {

                    switch (item.DocType) {

                        case 1:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                DocA: {
                                    files: null,

                                    DocType: 1,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;
                        case 2:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                DocB: {
                                    files: null,

                                    DocType: 2,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;
                        case 3:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                DocJ: {
                                    files: null,

                                    DocType: 3,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;
                        case 4:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                DocRaja: {
                                    files: null,
                                    DocType: 4,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));

                            break;
                        case 5:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                FileAnnouncement: {
                                    files: null,
                                    DocType: 5,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;
                        case 6:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                ScanContract: {
                                    files: null,
                                    DocType: 6,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;
                        case 7:
                            setDocs((prevDocs) => ({
                                ...prevDocs,
                                NationalCodeScan: {
                                    files: null,

                                    DocType: 7,
                                    showProgress: false,
                                    FileName: item.FileName
                                }
                            }));
                            break;

                        default:
                            break;
                    }
                });

            };






        }
        fetchData();
    }, []);

    const editUpload = async (name, ev, showProgress) => {
        ev.preventDefault();
        let method = '';
        const formData = new FormData();
        let config = {};
        let result;
        const file = ev.target.files[0];
        const fileType = file['type'];
        const size = file['size'];
        const validImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
        if(size > 1000000){
            alertProps(['danger', 'حجم فایل زیاد است']);
            return;
            
        }
        if (!validImageTypes.includes(fileType)) {
            alertProps(['danger', ' پسوندهای قابل قبول: jpg, png,jpeg']);
            return;
        }

        switch (name) {
            case 'FileAnnouncement':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    FileAnnouncement: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.FileAnnouncement.DocType}`;
                break;
            case 'ScanContract':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    ScanContract: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.ScanContract.DocType}`;
                break;
            case 'DocA':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocA: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.DocA.DocType}`;
                break;
            case 'DocB':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocB: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.DocB.DocType}`;
                break;
            case 'DocJ':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocJ: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.DocJ.DocType}`;
                break;
            case 'DocRaja':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocRaja: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.DocRaja.DocType}`;
                break;
            case 'NationalCodeScan':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    NationalCodeScan: {
                        files: file,
                        showProgress: true
                    }
                }));
                method = `UploadDoc/${Docs.NationalCodeScan.DocType}`;
                break;
            default:
                break;
        }

        formData.append("files", file);

        config = {
            onUploadProgress: progressEvent => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                setProgress(percentCompleted);
            }
        };

        //  try {
        result = await AgencyProfile(method, formData, config);

        if (result.status === 'success') {
            alertProps(['success', 'با موفقیت ثبت شد']);
            setColorBar('succuss-bar');
            setshowResult(true);
            setErr(false);



        } else {
            if (result.data.Errors) {
                alertProps(['danger', result.data.Errors.toString()]);
                setColorBar('danger-bar');
                setshowResult(true);
                setErr(true);

            } else {

                alertProps(['danger', result.data.Message]);
                setColorBar('danger-bar');
                setshowResult(true);
                setErr(true);


            }
        }


        switch (name) {
            case 'FileAnnouncement':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    FileAnnouncement: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'ScanContract':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    ScanContract: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'DocA':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocA: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'DocB':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocB: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'DocJ':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocJ: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'DocRaja':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    DocRaja: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            case 'NationalCodeScan':
                setDocs((prevDocs) => ({
                    ...prevDocs,
                    NationalCodeScan: {
                        showLbl: true,
                        files: file,
                        showProgress: false
                    }
                }));
                setColorBar('succuss-bar');
                break;
            default:
                break;
        }





    };

    return (

        <React.Fragment>
            <form
                method="POST"
                encType="multipart/form-data" >
                <Box
                    className={`bg-white rounded-lg border-solid border-light p-xl`}>

                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-8'>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Typography ms={{
                                            fontWeight: 'bold'
                                        }}>
                                            بارگزاری مجوزات
                                        </Typography>
                                    </Grid.Item>


                                    <Grid.Item className={``}
                                        size='col-12'>
                                        <Typography>
                                            <span> پسوندهای قابل قبول: jpg, png,jpeg</span>

                                            <span>(حداکثر حجم فایل: 1 مگابایت)</span>
                                        </Typography>
                                    </Grid.Item>
                                    {typeUser == 2 && <>

                                        <Grid.Item
                                            size='col-6'>
                                            <label>آگهی آخرین تغییرات</label>

                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('FileAnnouncement', event, true)}
                                                type='file'
                                            //  value={Docs.FileAnnouncement.FileName}

                                            />
                                            {Docs.FileAnnouncement.FileName}
                                            {Docs.FileAnnouncement.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}

                                                </Box>

                                            )}
                                            {Docs.FileAnnouncement.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.FileAnnouncement.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.FileAnnouncement.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }


                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>اسکن قرارداد مهر و امضا شده</label>
                                            <input
                                                type="file"
                                                onChange={(event) => editUpload('ScanContract', event, true)}
                                                type='file'
                                                className={`custom-file-input`}

                                            />
                                            {Docs.ScanContract.FileName}

                                            {Docs.ScanContract.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}

                                                </Box>

                                            )}
                                            {Docs.ScanContract.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.ScanContract.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.ScanContract.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>


                                    </>}
                                    {typeUser == 1 && <>

                                        <Grid.Item
                                            size='col-6'>
                                            <label>آگهی آخرین تغییرات</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('FileAnnouncement', event, true)}
                                                type='file'


                                            />
                                            {Docs.FileAnnouncement.FileName}
                                            {Docs.FileAnnouncement.showProgress && (
                                                <Box className="">
                                                    <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                        <span className={`float-right`}> در حال بارگزاری </span>

                                                        <span className={`float-left`}>
                                                            {progress}%</span>
                                                    </Typography>
                                                    {progress != 100 &&
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    }

                                                </Box>

                                            )}
                                            {Docs.FileAnnouncement.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.FileAnnouncement.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.FileAnnouncement.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>اسکن قرارداد مهر و امضا شده</label>
                                            <input
                                                type="file"
                                                onChange={(event) => editUpload('ScanContract', event, true)}
                                                type='file'
                                                className={`custom-file-input`}

                                            />
                                            {Docs.ScanContract.FileName}
                                            {Docs.ScanContract.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}


                                                </Box>

                                            )}
                                            {Docs.ScanContract.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.ScanContract.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.ScanContract.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>

                                        <Grid.Item
                                            size='col-6'>
                                            <label>سند الف</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('DocA', event, true)}
                                                type='file'


                                            />
                                            {Docs.DocA.FileName}
                                            {Docs.DocA.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}


                                                </Box>

                                            )}
                                            {Docs.DocA.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.DocA.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.DocA.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>سند ب</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('DocB', event, true)}
                                                type='file'


                                            />
                                            {Docs.DocB.FileName}
                                            {Docs.DocB.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}



                                                </Box>

                                            )}
                                            {Docs.DocB.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.DocB.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.DocB.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>سند ج</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('DocJ', event, true)}
                                                type='file'


                                            />
                                            {Docs.DocJ.FileName}

                                            {Docs.DocJ.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}


                                                </Box>

                                            )}
                                            {Docs.DocJ.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.DocJ.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.DocJ.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>سند رجا</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('DocRaja', event, true)}
                                                type='file'


                                            />
                                            {Docs.DocRaja.FileName}
                                            {Docs.DocRaja.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}



                                                </Box>

                                            )}
                                            {Docs.DocRaja.showLbl && <>
                                                {ColorBar == 'succuss-bar' &&
                                                    <span className="text-success">بارگزاری فایل {Docs.DocRaja.files.name} با موفقیت انجام شد.</span>
                                                }
                                                {
                                                    ColorBar == 'danger-bar' &&
                                                    <span className="text-danger">بارگزاری فایل {Docs.DocRaja.files.name} با مشکل مواجه شد.</span>
                                                }
                                            </>
                                            }
                                        </Grid.Item>


                                    </>}




                                    {typeUser == 3 && <>

                                        <Grid.Item
                                            size='col-6'>
                                            <label>اسکن کارت ملی</label>
                                            <input
                                                className={`custom-file-input`}
                                                type="file"
                                                onChange={(event) => editUpload('NationalCodeScan', event, true)}
                                                type='file'


                                            />
                                            {Docs.NationalCodeScan.FileName}
                                            {Docs.NationalCodeScan.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}



                                                </Box>

                                            )}
                                            {Docs.NationalCodeScan.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.NationalCodeScan.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.NationalCodeScan.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }
                                        </Grid.Item>
                                        <Grid.Item
                                            size='col-6'>
                                            <label>اسکن قرارداد مهر و امضا شده</label>
                                            <input
                                                type="file"
                                                onChange={(event) => editUpload('ScanContract', event, true)}
                                                type='file'
                                                className={`custom-file-input`}

                                            />
                                            {Docs.ScanContract.FileName}
                                            {Docs.ScanContract.showProgress && (
                                                <Box className="">
                                                    {progress != 100 && <>
                                                        <Typography className='w-100' ms={{ fontSize: '12px' }}>
                                                            <span className={`float-right`}> در حال بارگزاری </span>

                                                            <span className={`float-left`}>
                                                                {progress}%</span>
                                                        </Typography>
                                                        <progress
                                                            className={ColorBar == 'succuss-bar' ? 'succuss-bar w-100' : 'danger-bar w-100'} value={progress} max="100"></progress>
                                                    </>}


                                                </Box>

                                            )}
                                            {Docs.ScanContract.showLbl && <>
                                                {Err == false && <span className="text-success">بارگزاری فایل {Docs.ScanContract.files.name} با موفقیت انجام شد.</span>}
                                                {Err == true && <span className="text-danger">بارگزاری فایل {Docs.ScanContract.files.name} با مشکل مواجه شد.</span>}
                                            </>
                                            }

                                        </Grid.Item>


                                    </>}
                                </Grid.Wrapper>
                            </Grid.Item>

                            <Grid.Item
                                size='col-4'>
                                <Image
                                    src={profileImg}
                                    ms={{
                                        background: '#F5F5F7',
                                        borderRadius: '16px'

                                    }}
                                />
                            </Grid.Item>

                        </Grid.Wrapper>

                    </Grid>

                </Box>

            </form>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>

        </React.Fragment>
    )
}
